import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import HttpClient from "../../utils/HttpClient";
import facebook_icon from "../../Images/facebook_icon.png";
import insta_icon from "../../Images/insta_icon.png";
import linkedin_icon from "../../Images/linkedin_icon.png";
import cameralogo from "../../../src/Images/cameralogo.png";
import searchhomeprofileimg from "../../../src/Images/searchhomeprofileimg.png";
import moment from "moment/moment";
import StarRating from "./StarRating";
import RewardPoints from "../../utils/RewardPoints";
import { openWindow } from "../../Component/OpenWhatsApp";

const BusinessOverview = ({ singleData }) => {
    const { UserProfileID } = useSelector((state) => state.app);
    const [sponsorAdImage, setSponsorAdImage] = useState({})
    const [isMobile, setIsMobile] = useState(false);
    const [company, setCompany] = useState([]);
    const [country, setCountry] = useState([]);
    const [designation, setDesignation] = useState([]);

    const getCompanyName = (_id) => {
        const companyName = company.find((company) => company._id === _id);
        return companyName ? companyName.type : "";
    };

    const getCompany = async () => {
        const response = await HttpClient.requestData("companyType", "GET", "");
        if (response?.status) {
            setCompany(response.data);
        } else {
            console.log("Error while fetching company data");
        }
    };

    const getCountry = async () => {
        const response = await HttpClient.requestData("countries-list", "GET", "");
        if (response.status) {
            setCountry(response.data);
        } else {
            console.log("Error while fetching country data");
        }
    };

    const getDesignation = async () => {
        const response = await HttpClient.requestData("designation", "GET", "");
        if (response.status) {
            setDesignation(response.data);
        } else {
            console.log("Error while fetching designation data");
        }
    };

    const getSponsorAd = async () => {
        const response = await HttpClient.requestData("all-sponserAd", "GET", "");
        if (response.status) {
            setSponsorAdImage(response.data[0] || {});
        } else {
            console.log("Error while fetching company data");
        }
    };

    const getCountryName = (_id) => {
        const countryName = country.find((countr) => countr._id === _id);
        return countryName ? countryName.name : "United Arab Emirates";
    };

    useEffect(() => {
        getCompany();
        getCountry()
        getDesignation()
        getSponsorAd()
        if (window.innerWidth <= 768) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, []);

    const handleLinkClick = async (e, link, id, visitType, subType = '') => {
        if (e && typeof e.preventDefault === "function") {
            e.preventDefault();
        }

        if (!link) return;

        // normalize link to ensure it has a protocol so window.open works for "abclimited.com"
        const normalize = (l) => {
            let u = String(l).trim();
            if (!/^https?:\/\//i.test(u)) u = `https://${u}`;
            return encodeURI(u);
        };

        try {
            await addRewardPoints(id, visitType, subType);
            openWindow(normalize(link));
        } catch (err) {
            console.error("Error opening website link:", err);
        }
    };

    const addRewardPoints = async (id, visitType, subType = '') => {
        return await HttpClient.requestData("getting-rewards", "POST", { profileId: id, type: visitType, subType });
    }

    return (
        <>     {singleData ? (
            <>
                {
                    singleData.status === "Active" ? (
                        <>
                            <div className="ownseacrgresultpageright" data-spy="scroll" data-target="#navbar-example3" data-offset="0">
                                <p className="prPremiumofiletxtp">{singleData?._id === UserProfileID?._id ? "Your page" : singleData.memberStatus ? "Premium profile" : ""}</p>
                                <div className="ownseacrgresultpagerightbrdr">
                                    <div
                                        className="ownseacrgresultpagerightbrdrtop"
                                    // onClick={handleotherserchresult}
                                    >
                                        <div className="ownseacrgresultpagerreslppimg">
                                            <img src={singleData?.businesBanner || "https://st.depositphotos.com/2934765/53192/v/450/depositphotos_531920820-stock-illustration-photo-available-vector-icon-default.jpg"} alt="..." />
                                        </div>

                                        <div className="logostrdetyskksldovkkdpo">
                                            <div className="logostretdijjkkkljujuo">
                                                {/* <img src={singleData?.businessProfilePic} alt="..." /> */}
                                                <img src={singleData?.businessProfilePic || cameralogo} alt="..."
                                                    style={{
                                                        border: "solid 3px #fff",
                                                    }}
                                                />
                                            </div>
                                            <div className="allttehdiioskjetyapasedoib">
                                                {
                                                    singleData?.businessStatus ? (
                                                        <>
                                                            <Link
                                                                to={`/businesspage/${singleData?.companySlug}`}
                                                                className="neosertsttfzrrtty"
                                                            >
                                                                {singleData?.companyName}
                                                            </Link>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <p className="neosertsttfzrrtty">
                                                                {singleData?.companyName}
                                                            </p>
                                                        </>
                                                    )
                                                }
                                                <p className="neosertsttfzrrttyadfd">
                                                    {getCompanyName(singleData?.companyTypeID)}
                                                </p>
                                                <div className="dofleoodiistartdivflx">
                                                    {/* <p className="neosertsttfzrrttyadfdfff"> */}
                                                      <Link className="btn btn-success m-2 fs-6" to={`/businesspage/${singleData?.companySlug}`}>
                                                        View Page
                                                      </Link>
                                                    {/* </p> */}

                                                    <div className="statrrdibvggshhghuju mt-2">
                                                        {singleData?.avgBusinessRating > 0 && (
                                                            <div style={{ fontFamily: "Arial" }}>
                                                                <span style={{}}><strong >{singleData?.avgBusinessRating}</strong> <StarRating rating={singleData?.avgBusinessRating} /></span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ownseacrgresultpagerightbrdrtopbottom">
                                        <div className="">
                                            <p className="tttxtyaplattsyggjjkllkkk">
                                                {singleData?.location}
                                            </p>
                                            <p className="tttxtyaplattsyggjjkllkkk">
                                                {singleData?.emirate},{" "}
                                                {getCountryName(singleData?.country)}
                                            </p>

                                            <p className="phokennsjjsnyunnrbtk">
                                                Phone: {singleData?.phone_code} {singleData?.mobileNo}
                                            </p>

                                            <Link className="serttxtghsytxoppjkjo" to="/">
                                                {singleData?.webAddress}
                                            </Link>

                                            <p className="opperpoodshheyxgbpppn">{ }</p>
                                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                                {singleData?.businessProductCat?.map((it, index) => (
                                                    <p
                                                        className="diisjadfebnclkmdgragjksopjkl"
                                                        key={index}
                                                        style={{
                                                            marginLeft: "2px",
                                                        }}
                                                    >
                                                        {it}{singleData?.businessProductCat.length > index + 1 && (" | ")}
                                                    </p>
                                                ))}
                                            </div>

                                            {
                                                singleData?.memberStatus &&
                                                <>
                                                    <div className="viewprofileimgaedivvhjjnflx">
                                                        <div className="prijjdhjjjjkjaaimg">
                                                            <img className="img" src={singleData?.profilePhoto || searchhomeprofileimg} alt="..." />
                                                        </div>
                                                        <Link
                                                            to={`/profile/${singleData?.userName?.trim()}`}
                                                            className="bvhhjjapsidhbfbbrkjk"
                                                        >
                                                            View profile
                                                        </Link>
                                                    </div>
                                                </>
                                            }


                                            <div className="">
                                                <p className="sclloidjjdttxppphjo">Social links</p>
                                                <div className="socijjjsjkjijnndnkdobvbbhflx">
                                                    <Link
                                                        href="#"
                                                        onClick={(e) => handleLinkClick(e, singleData?.facebookLink, singleData?._id, RewardPoints.SOCIAL_LINK_VISIT_TYPE, RewardPoints.SOCIAL_LINK_VISIT_TYPE_FB)}
                                                        // to={singleData?.facebookLink}
                                                        className="socijjjsjkjijnndnk"
                                                    >
                                                        <img src={facebook_icon} alt="..." />
                                                    </Link>
                                                    <Link
                                                        // to={singleData?.instaLink}
                                                        onClick={(e) => handleLinkClick(e, singleData?.instaLink, singleData?._id, RewardPoints.SOCIAL_LINK_VISIT_TYPE, RewardPoints.SOCIAL_LINK_VISIT_TYPE_IG)}
                                                        className="socijjjsjkjijnndnk"
                                                    >
                                                        <img src={insta_icon} alt="..." />
                                                    </Link>
                                                    <Link
                                                        // to={singleData?.linkedInLink}
                                                        onClick={(e) => handleLinkClick(e, singleData?.linkedInLink, singleData?._id, RewardPoints.SOCIAL_LINK_VISIT_TYPE, RewardPoints.SOCIAL_LINK_VISIT_TYPE_LI)}
                                                        className="socijjjsjkjijnndnk"
                                                    >
                                                        <img src={linkedin_icon} alt="..." />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="ownseacrgresultpageright">
                                <p className="prPremiumofiletxtp">Page is not available</p>
                            </div>

                        </>
                    )
                }
            </>

        ) : (
            !isMobile &&
            <div className="ownseacrgresultpageright">
                <p className="prPremiumofiletxtp">Sponsor Ad</p>
                {
                    sponsorAdImage && (moment(sponsorAdImage?.expiryDate, "YYYY-MM-DD").isAfter(moment().startOf("day")) || moment(sponsorAdImage?.expiryDate, "YYYY-MM-DD").isSame(moment().startOf("day"))) ?
                        <div>
                            <a href={sponsorAdImage?.adLinkUrl} target="_blank">
                                <img src={sponsorAdImage?.adImage}
                                    style={{
                                        maxWidth: "100%"
                                    }}
                                />
                            </a>
                        </div> :
                        <div className="boxosimaggedisahdowdiv">
                            <p className="tsttsggsiijxbhnsimag">300x250</p>
                        </div>
                }
            </div>
        )}
        </>

    );
};

export default BusinessOverview;